export enum ChainIds {
    POLYGON = 137,
    MUMBAI = 80001
}